import React from "react";
import SearchInput from "../../design-system/SearchInput";
import { Img } from "../../design-system/Img";
import { debitOrCredit } from "../../../../constants/config";
import { Text } from "../../design-system/Text";
import { dateService } from "../../../../services/dateService";
import { DateFormats } from "../../../../constants/dateFormats";
import { formatCurrency } from "../../../../utils/currencyFormatter";

interface TableProps {
  transactionsList?: any[];
}

const tableData = [
  {
    payee: "Mr. Bones",
    refNo: "879024865902",
    date: "3/4/24, 10:32 AM",
    type: "credit",
    amount: "AED 31,925",
  },
];

const Table: React.FC<TableProps> = (props) => {
  const nameProvider = (data: any) => {
    console.log("data_TABLE:>", data);

    if (data.type === "OWN_ACCOUNT_TRANSFER") {
      if (data.debitOrCredit === debitOrCredit.credit) {
        return data.fromAccountName;
      } else {
        return data.toAccountName ?? data.fromAccountName;
      }
    } else {
      return data.beneficiaryName;
    }
  };
  const usersProfilePhotos = [
    "14.jpg",
    "17.jpg",
    "20.jpg",
    "51.jpg",
    "65.jpg",
    "94.jpg",
    "1.jpg",
    "67.jpg",
    "74.jpg",
  ];
  return (
    <div className="border border-lightGray bg-white-A700 rounded-lg shadow-sm flex-[1]">
      <div className="flex flex-row justify-between items-center px-[24px] py-[20px] ">
        <Text className="xs:font-medium xs:!text-lg 5xl:!text-xl 5xl:font-normal">
          Latest Transactions
        </Text>

        <SearchInput id="si_324234" />
      </div>
      <div className="overflow-scroll no-scrollbar">
        <table className="table-auto w-full flex-[1]">
          <thead>
            <tr>
              {Object.keys(tableData[0]).map((key, index) => (
                <th
                  key={"table_head_" + index}
                  className="px-6 py-4 text-[0.75rem] border-lightGray xs:font-medium 5xl:font-normal text-left border border-x-0 5xl:text-lg"
                >
                  {key.replace(/^\w/, (c) => c.toUpperCase())}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props?.transactionsList && props.transactionsList.length === 0 && (
              <tr>
                <td
                  colSpan={Object.keys(tableData[0]).length}
                  className="text-center py-4"
                >
                  No transactions found.
                </td>
              </tr>
            )}

            {props?.transactionsList &&
              props.transactionsList.map((data, index) => (
                <tr key={"table_row_" + index}>
                  <td
                    key={"table_data_" + index}
                    className="border border-x-0 border-t-0 border-lightGray"
                  >
                    <div className="flex flex-row items-center xs:gap-2 5xl:gap-4 px-6 py-4">
                      <Img
                        src={usersProfilePhotos[index]}
                        alt="profile"
                        className="xs:size-10 rounded-full 5xl:size-14"
                      />
                      <Text className="xs:!text-md 5xl:!text-xl 5xl:font-normal text-left text-black-700">
                        {nameProvider(data)}
                      </Text>
                    </div>
                  </td>

                  <td
                    key={"table_data_" + index}
                    className="border border-x-0  border-t-0 border-lightGray "
                  >
                    <div className="flex flex-row items-center gap-2 px-6 py-4">
                      <Text className="xs:!text-md 5xl:!text-xl 5xl:font-normal text-black-700">
                        {data.id.slice(0, 8) + "..."}
                      </Text>
                    </div>
                  </td>
                  

                  <td
                    key={"table_data_" + index}
                    className="border border-x-0 border-t-0 border-lightGray "
                  >
                    <div className="flex flex-row items-center gap-2 px-6 py-4">
                      <Text className="xs:!text-md 5xl:!text-xl 5xl:font-normal text-black-700">
                        {!!data.transactionDate &&
                          `${dateService.format(
                            data.transactionDate,
                            DateFormats.extended.normalDateTime
                          )}`}
                      </Text>
                    </div>
                  </td>

                  <td
                    key={"table_data_" + index}
                    className="border border-x-0  border-t-0 border-lightGray"
                  >
                    <div className="flex flex-row items-center gap-2  px-6 py-4">
                      <Text
                        className={`xs:!text-md 5xl:!text-xl 5xl:font-normal py-[2px] px-[8px] rounded-lg ${
                          data.type === "DEBIT"
                            ? `bg-red-200 text-red-500`
                            : `bg-green-200 text-green-500`
                        }`}
                      >
                        {!!data.debitOrCredit ? data.debitOrCredit : "DEBIT"}
                      </Text>
                    </div>
                  </td>

                  <td
                    key={"table_data_" + index}
                    className="border border-x-0  border-t-0 border-lightGray "
                  >
                    <div className="flex flex-row items-center gap-2  px-6 py-4">
                      <Text className="xs:!text-md 5xl:!text-xl 5xl:font-normal">
                      {formatCurrency(data.amount)}
                      </Text>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
